'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormGroup = require('../FormGroup');

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _SelectControls = require('./SelectControls');

var _SelectControls2 = _interopRequireDefault(_SelectControls);

var _SelectInputController = require('./SelectInputController');

var _SelectInputController2 = _interopRequireDefault(_SelectInputController);

var _SelectMenu = require('./SelectMenu');

var _SelectMenu2 = _interopRequireDefault(_SelectMenu);

var _OutsideAlerter = require('../../Utility/OutsideAlerter');

var _OutsideAlerter2 = _interopRequireDefault(_OutsideAlerter);

var _screenService = require('../../../services/screenService');

var _screenService2 = _interopRequireDefault(_screenService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Select = function (_PureComponent) {
  _inherits(Select, _PureComponent);

  function Select(props) {
    _classCallCheck(this, Select);

    var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _this.handleSelection = function (selectedOption) {
      var mobileCloseOnChange = _this.props.mobileCloseOnChange;


      if (!mobileCloseOnChange && _screenService2.default.isMobile()) {
        _this.props.handleSelection(selectedOption);
        _this.setState({
          filter: null
        });
      } else {
        _this.handleDone(selectedOption);
      }
    };

    _this.handleMenuDone = function () {
      _this.props.selectedOptions.map(function (selectedOption) {
        _this.props.onDone(selectedOption);
      });
      _this.closeMenu();
    };

    _this.handleDone = function (selectedOption) {
      _this.props.onDone(selectedOption);
      _this.closeMenu();
    };

    _this.handleCancel = function () {
      _this.closeMenu();
    };

    _this.updateFilter = function (filter) {
      _this.props.onInputChange(filter);
      _this.setState({ filter: filter });
    };

    _this.isDisabled = function () {
      var _this$props = _this.props,
          options = _this$props.options,
          disabled = _this$props.disabled;

      return disabled || options.length === 0;
    };

    _this.openMenu = function () {
      if (_screenService2.default.isMobile()) {
        document.body.style.overflow = 'hidden';
      }
      _this.setState({ menuIsOpen: true });
    };

    _this.closeMenu = function () {
      document.body.style.overflow = 'unset';
      _this.setState({ menuIsOpen: false, filter: null });
    };

    _this.state = {
      menuIsOpen: false,
      filter: null
    };
    return _this;
  }

  _createClass(Select, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          menuIsOpen = _state.menuIsOpen,
          filter = _state.filter;

      var _props = this.props,
          text = _props.text,
          displayKey = _props.displayKey,
          valueKey = _props.valueKey,
          stylingKey = _props.stylingKey,
          defaultOptionText = _props.defaultOptionText,
          mobileCloseOnChange = _props.mobileCloseOnChange,
          MenuComponent = _props.MenuComponent,
          selectedOptions = _props.selectedOptions,
          className = _props.className,
          errors = _props.errors,
          otherProps = _objectWithoutProperties(_props, ['text', 'displayKey', 'valueKey', 'stylingKey', 'defaultOptionText', 'mobileCloseOnChange', 'MenuComponent', 'selectedOptions', 'className', 'errors']);

      var wrapperClass = 'Select-wrapper ' + (menuIsOpen ? 'active' : '');

      return _react2.default.createElement(
        _FormGroup2.default,
        {
          className: 'Select-root ' + className,
          text: text,
          errors: errors
        },
        _react2.default.createElement(
          _OutsideAlerter2.default,
          { className: wrapperClass, onAlert: this.closeMenu },
          _react2.default.createElement(_SelectControls2.default, {
            handleCancel: this.handleCancel,
            handleDone: this.handleMenuDone,
            doneEnabled: selectedOptions.length > 0,
            menuIsOpen: menuIsOpen,
            mobileCloseOnChange: mobileCloseOnChange
          }),
          _react2.default.createElement(
            'div',
            { className: 'Select-controls-container' },
            _react2.default.createElement(_SelectInputController2.default, _extends({}, otherProps, {
              displayKey: displayKey,
              stylingKey: stylingKey,
              openMenu: this.openMenu,
              filter: filter,
              selectedOptions: selectedOptions,
              onInputChange: this.updateFilter,
              menuIsOpen: menuIsOpen,
              onRemove: this.handleDone
            })),
            _react2.default.createElement(MenuComponent, {
              displayKey: displayKey,
              valueKey: valueKey,
              stylingKey: stylingKey,
              selectedOptions: selectedOptions,
              filter: filter,
              options: this.props.options,
              menuIsOpen: menuIsOpen,
              onChange: this.handleSelection
            })
          )
        )
      );
    }
  }]);

  return Select;
}(_react.PureComponent);

Select.propTypes = {
  text: _propTypes2.default.string.isRequired,
  onDone: _propTypes2.default.func.isRequired,
  handleSelection: _propTypes2.default.func.isRequired,
  onInputChange: _propTypes2.default.func,
  value: _propTypes2.default.any,
  multiple: _propTypes2.default.bool,
  options: _propTypes2.default.array.isRequired,
  displayKey: _propTypes2.default.string.isRequired,
  valueKey: _propTypes2.default.string,
  stylingKey: _propTypes2.default.string,
  defaultOptionText: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  name: _propTypes2.default.string,
  className: _propTypes2.default.string.isRequired,
  errors: _propTypes2.default.array,
  mobileCloseOnChange: _propTypes2.default.bool.isRequired,
  MenuComponent: _propTypes2.default.func.isRequired
};

Select.defaultProps = {
  value: '',
  multiple: false,
  closedPlaceholder: 'Please choose one...',
  searchPlaceholder: 'Start typing to search...',
  options: [],
  displayKey: 'text',
  disabled: false,
  mobileCloseOnChange: false,
  className: '',
  MenuComponent: _SelectMenu2.default,
  onInputChange: function onInputChange() {
    return undefined;
  }
};

exports.default = Select;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Select/Select.js
// module id = 230
// module chunks = 0